import * as Yup from 'yup';

const contractValiditySchema = Yup.object().shape({
  policyNumber: Yup.string()
    .matches(/^[a-zA-Z]{2}\/\d{6}$/, 'validationErrors.invalidContractNumber')
    .required('validationErrors.isRequired'),
});

export default contractValiditySchema;
